export const WALLBOARD_PATH = '/wallboard';
export const WALLBOARD_READ_ONLY_ERROR = 'A wallboard is read-only.';

export const WallboardConst = {
  requestHeaders: { 'X-Nimbus-Wallboard': 'true' },
  transientRetry: {
    maxRetries: 10,
    delayStepMs: 10000,
    delayMaxMs: 60000,
  },
  renew: {
    minDelayMs: 10000,
    retryDelayMs: 60000,
  },
};
